const xlsx  = require('xlsx')
const downF  = require('../helpers/downloadFile')

module.exports = async function (path, type) {
    var file = await downF(path)
    const XLSX = xlsx
    var obj = {}

    if (type == "pz-cg") {
        var readingsPZA = await getReadingsPZ(file, XLSX, 1, type)
        var readingsPZB = await getReadingsPZ(file, XLSX, 2., type)


        obj = {
            "Nivel de agua contra nivel de terreno": readingsPZA,
            "Variacion de la columna de agua": readingsPZB
        }
    } else if (type == "pz-hv") {
        var readingsPZA = await getReadingsPZ(file, XLSX, 1, type)
        obj = {
            "Nivel de agua desde la superficie": readingsPZA
        }
    }
    return obj
}

async function getReadingsPZ(workbook, XLSX, page, type) {
    //getLadoA(1)
    const wsname = workbook.SheetNames[page]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
    const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
    var SeriesData = [];
    var options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    }

    for (var i = 0; i < ws.length; i++) {
        var date
        if (type == "pz-cg") {
            date = new Date(ws[i]["__EMPTY_1"])
        }
        else if (type == "pz-hv") {
            date = new Date(ws[i]["__EMPTY_2"])
        }
        if (date instanceof Date && !isNaN(date.valueOf())) {
            if (type == "pz-cg") {
                if (ws[i]["__EMPTY_2"] != null) {
                    var obj = {
                        y: ws[i]["__EMPTY_2"],
                        x: new Date(ws[i]["__EMPTY_1"]).toLocaleDateString("es-ES", options),
                    };
                    SeriesData.push(obj);
                }
            }
            else if (type == "pz-hv") {
                if (ws[i]["__EMPTY_7"] != null) {
                    var obj = {
                        y: ws[i]["__EMPTY_7"],
                        x: new Date(ws[i]["__EMPTY_2"]).toLocaleDateString("es-ES", options),
                    };
                    SeriesData.push(obj);
                }
            }
        }
    }
    return SeriesData;
}